import GetProductNameBySku from "../queries/GetProductNameBySku.pim.js";
import Logger from "@cappelendamm/logger";
export const fetchProductNameBySku = async ({ sku }, { client }) => {
    const productNameBySku = await client.pim.request(GetProductNameBySku, {
        sku: sku,
        tenantId: client.tenantId,
    });
    const product = selectProduct(productNameBySku);
    if (!product) {
        Logger.log("Failed to fetch product name by sku. Error: No product found with sku: " +
            sku);
        return undefined;
    }
    if (!product.name) {
        Logger.log("Failed to fetch product name by sku. Error: No product name found for sku: " +
            sku);
        return undefined;
    }
    return product.name;
};
function selectProduct(productQuery) {
    return productQuery?.product?.getVariants?.[0]?.product;
}
